// Componente que inicializa o sistema de notificações push mobile
// Apenas para mobile (Android/iOS) - funciona mesmo com navegador fechado
// Separado completamente do sistema desktop/admin

import { useEffect } from 'react';
import { initializeMobilePushNotifications } from '../utils/mobile-push-notifications';

export default function MobilePushInitializer() {
  useEffect(() => {
    // Inicializar sistema de notificações push mobile apenas uma vez
    initializeMobilePushNotifications().then((initialized) => {
      if (initialized) {
        console.log('✅ Sistema de notificações push mobile inicializado');
      } else {
        console.log('📱 Sistema de notificações push mobile não inicializado (não é mobile ou erro)');
      }
    });
  }, []);

  // Este componente não renderiza nada
  return null;
}

